import './docbookHref'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import WechatUtils from '@utils/wechat'
import NativeBridge from '@utils/nativeBridge'
const wechatUtils = new WechatUtils()
Vue.prototype.$wx = wechatUtils
Vue.config.productionTip = false


const vm = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

const bridge = new NativeBridge({
    vm
})

Vue.prototype.$nativeBridge = bridge



window.native2js = function (message) {
    if (!message) return
    return bridge.handleMessage(message)
}


export default vm